import { Button, Spinner } from "react-bootstrap";

interface Props {
  onClick: () => void;
  running: boolean;
}

export const DownloadButton: React.FunctionComponent<Props> = (props) => {
  const txt = props.running ? "Downloading..." : "Download";

  const spinner = props.running ? <Spinner animation="border" /> : null;

  return (
    <Button
      onClick={props.onClick}
      disabled={props.running}
      style={{ marginRight: "10px", float: "right" }}
      variant="success">
      {txt} {spinner}
    </Button>
  );
};
